var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStandard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 60.5H60.25V0.5H0.25V60.5Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95801 48.4095H37.2356C39.6491 48.4095 41.6058 46.4572 41.6058 44.0393V16.2781L26.7491 1.39453H11.3282C8.91472 1.39453 6.95801 3.34677 6.95801 5.76468V48.4095Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95801 48.4095H37.2356C39.6491 48.4095 41.6058 46.4572 41.6058 44.0393V16.2781L26.7491 1.39453H11.3282C8.91472 1.39453 6.95801 3.34677 6.95801 5.76468V48.4095Z",
    stroke: "url(#paint0_linear_901_3361)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5968 16.2423H31.1192C28.7057 16.2423 26.749 14.2901 26.749 11.8721V1.39453L41.5968 16.2423Z",
    fill: "url(#paint1_linear_901_3361)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5968 16.2423H31.1192C28.7057 16.2423 26.749 14.2901 26.749 11.8721V1.39453L41.5968 16.2423Z",
    stroke: "url(#paint2_linear_901_3361)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95743 6.34766H6.37534C3.97893 6.36557 2.04549 8.30885 2.04102 10.7089V48.9924C2.05534 51.3835 3.98609 53.3178 6.37534 53.3357H32.2828C33.4416 53.3357 34.5538 52.879 35.3733 52.0551C36.1927 51.2402 36.653 50.1208 36.653 48.9656V48.4103H11.3276C8.91415 48.4103 6.95743 46.4581 6.95743 44.0402V6.34766Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95743 6.34766H6.37534C3.97893 6.36557 2.04549 8.30885 2.04102 10.7089V48.9924C2.05534 51.3835 3.98609 53.3178 6.37534 53.3357H32.2828C33.4416 53.3357 34.5538 52.879 35.3733 52.0551C36.1927 51.2402 36.653 50.1208 36.653 48.9656V48.4103H11.3276C8.91415 48.4103 6.95743 46.4581 6.95743 44.0402V6.34766Z",
    stroke: "url(#paint3_linear_901_3361)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 29.4517H24.5102",
    stroke: "url(#paint4_linear_901_3361)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 21.6978H29.9998",
    stroke: "url(#paint5_linear_901_3361)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 25.5728H29.9998",
    stroke: "url(#paint6_linear_901_3361)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.257 41.45L49.687 34.23C49.224 33.76 48.594 33.5 47.937 33.5C47.28 33.5 46.65 33.76 46.187 34.23C45.722 34.69 45.46 35.32 45.46 35.98C45.46 36.64 45.722 37.27 46.187 37.73L46.267 37.81L46.187 37.73L44.387 35.99C43.924 35.52 43.294 35.26 42.637 35.26C41.98 35.26 41.35 35.52 40.887 35.99C40.619 36.27 40.424 36.62 40.317 36.99V38.55C40.424 38.92 40.619 39.27 40.887 39.55L42.717 41.38L40.887 39.55L40.387 38.93L39.207 37.75C38.744 37.28 38.114 37.02 37.457 37.02C36.8 37.02 36.17 37.28 35.707 37.75C35.242 38.21 34.98 38.84 34.98 39.5C34.98 40.16 35.242 40.79 35.707 41.25L39.247 44.87L35.667 41.29L30.477 36.1C30.014 35.63 29.384 35.37 28.727 35.37C28.07 35.37 27.44 35.63 26.977 36.1C26.512 36.56 26.25 37.19 26.25 37.85C26.25 38.51 26.512 39.14 26.977 39.6L36.507 49.13L40.137 52.76L31.337 54.14C29.838 54.34 28.724 55.63 28.737 57.14C28.748 58.09 29.522 58.86 30.477 58.87H47.017C49.343 58.87 51.573 57.94 53.217 56.3L55.977 53.54C59.286 50.23 59.414 44.91 56.267 41.45H56.257Z",
    fill: "url(#paint7_linear_901_3361)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.257 41.45L49.687 34.23C49.224 33.76 48.594 33.5 47.937 33.5C47.28 33.5 46.65 33.76 46.187 34.23C45.722 34.69 45.46 35.32 45.46 35.98C45.46 36.64 45.722 37.27 46.187 37.73L46.267 37.81L46.187 37.73L44.387 35.99C43.924 35.52 43.294 35.26 42.637 35.26C41.98 35.26 41.35 35.52 40.887 35.99C40.619 36.27 40.424 36.62 40.317 36.99V38.55C40.424 38.92 40.619 39.27 40.887 39.55L42.717 41.38L40.887 39.55L40.387 38.93L39.207 37.75C38.744 37.28 38.114 37.02 37.457 37.02C36.8 37.02 36.17 37.28 35.707 37.75C35.242 38.21 34.98 38.84 34.98 39.5C34.98 40.16 35.242 40.79 35.707 41.25L39.247 44.87L35.667 41.29L30.477 36.1C30.014 35.63 29.384 35.37 28.727 35.37C28.07 35.37 27.44 35.63 26.977 36.1C26.512 36.56 26.25 37.19 26.25 37.85C26.25 38.51 26.512 39.14 26.977 39.6L36.507 49.13L40.137 52.76L31.337 54.14C29.838 54.34 28.724 55.63 28.737 57.14C28.748 58.09 29.522 58.86 30.477 58.87H47.017C49.343 58.87 51.573 57.94 53.217 56.3L55.977 53.54C59.286 50.23 59.414 44.91 56.267 41.45H56.257Z",
    stroke: "url(#paint8_linear_901_3361)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_901_3361",
    x1: 24.2819,
    y1: 1.39453,
    x2: 24.2819,
    y2: 48.4095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_901_3361",
    x1: 34.1729,
    y1: 1.39453,
    x2: 34.1729,
    y2: 16.2423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_901_3361",
    x1: 34.1729,
    y1: 1.39453,
    x2: 34.1729,
    y2: 16.2423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_901_3361",
    x1: 19.347,
    y1: 6.34766,
    x2: 19.347,
    y2: 53.3357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_901_3361",
    x1: 17.9192,
    y1: 29.0039,
    x2: 17.9192,
    y2: 29.8994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_901_3361",
    x1: 20.6639,
    y1: 21.25,
    x2: 20.6639,
    y2: 22.1455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_901_3361",
    x1: 20.6639,
    y1: 25.125,
    x2: 20.6639,
    y2: 26.0205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_901_3361",
    x1: 42.3978,
    y1: 33.5,
    x2: 42.3978,
    y2: 58.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_901_3361",
    x1: 42.3978,
    y1: 33.5,
    x2: 42.3978,
    y2: 58.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#084277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E6E90"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/Standard.7e7b11d353912d15bfe98012a9d06ca9.svg";
export { ForwardRef as ReactComponent };